import React from 'react';
import { SectionLayout } from 'components/Sections/SectionLayout';
import ContentBlock from 'components/ContentBlock';
import RowContent from 'components/RowContent';
import InPageFeaturesV1 from 'components/InPageFeatures/InPageFeaturesV1';
import InPageFeaturesV2 from 'components/InPageFeatures/InPageFeaturesV2';
import InPageFeaturesV3 from 'components/InPageFeatures/InPageFeaturesV3';
import colorTypeHelper from 'utils/colorTypeHelper';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import Section from 'components/Section';

const ToggleContent = ({ item }) => {
  const typeName = item?.__typename;

  if (typeName === 'ContentfulWebsiteContentBlock') {
    return <ContentBlock data={item} />;
  } else if (typeName === 'ContentfulRowContent') {
    const { backgroundCornerImage, backgroundImage, flipBackgroundImage, fullWidthContent } = item;
    return (
      <RowContent
        bgCornerImg={backgroundCornerImage}
        bgImg={backgroundImage?.image?.fluid?.src}
        bgFlip={flipBackgroundImage}
        fullWidth={fullWidthContent}
        {...item}
      />
    );
  } else if (typeName === 'ContentfulRichText') {
    return (
      <SectionLayout>
        <ContentfulRichText richText={item} />
      </SectionLayout>
    );
  } else if (typeName === 'ContentfulSection') {
    return <Section data={{ ...item, spacing: 'None' }} />;
  } else if (typeName === 'ContentfulInPageFeatures') {
    if (item?.useV2Styling) {
      return (
        <InPageFeaturesV2
          background={item?.bg}
          title={item?.title}
          description={!isNil(item?.description) ? item?.description.description : ''}
          inPageNavigation={item?.inPageNavigationItems}
          backgroundColor={colorTypeHelper[item?.bgColor]}
        />
      );
    } else if (item?.useV3Styling) {
      return <InPageFeaturesV3 {...item} toggleComponent />;
    } else {
      return (
        <InPageFeaturesV1
          background={item?.bg}
          title={item?.title}
          description={!isNil(item?.description) ? item?.description.description : ''}
          inPageNavigation={item?.inPageNavigationItems}
          backgroundColor={BackgroundColorType[item?.bgColor]}
        />
      );
    }
  } else {
    return item;
  }
};

export default ToggleContent;
